"use strict";
var _ = require("lodash");
var Cookies = require("js.cookie");
var CookieConsentUtils = (function () {
    function CookieConsentUtils() {
    }
    CookieConsentUtils.init = function () {
        if (app.isAuthenticated || Cookies.get("CookieConsent") == "Accepted")
            return;
        document.addEventListener("DOMContentLoaded", function () {
            var cookieConsent = document.getElementById("cookieConsent");
            var acceptCookie = document.getElementById("acceptCookie");
            cookieConsent.style.display = "flex";
            acceptCookie.addEventListener("click", function () {
                var date = new Date();
                date.setFullYear(date.getFullYear() + 1);
                Cookies.set("CookieConsent", "Accepted", { expires: date });
                cookieConsent.style.display = "none";
            });
        });
    };
    return CookieConsentUtils;
}());
_.extend(window["AppUtils"], {
    CookieConsent: CookieConsentUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CookieConsentUtils;
//# sourceMappingURL=cookieConsentUtils.js.map